export const LocationContract  = {
    
    async index(page, per_page, search, fields) {
        page;
        per_page;
        search;
        fields;
        throw new Error("locations index not implemented");
    },

    async download_barcode(ids) {
        ids;
        
        throw new Error("locations download_barcode not implemented");
    }    
}